import {Model, ModelMixin} from '../common/model.class';
import ProjectionInformation = Model.ProjectionInformation;

/**
 * Created by Rodrigo Quesada on 04/12/16.
 */
export class DisciplinaryActions extends ModelMixin() implements Model<DisciplinaryActions> {

    TYPE = DisciplinaryActions;
    static projectionInformation = new ProjectionInformation('disciplinaryActions');

    public investigationSubject: boolean;
    public convictedOrCharged: boolean;
    public censured: boolean;
    public licensingBoardInquirySubject: boolean;
    public licenseWithdrawal: boolean;
    public facilityMembershipWithdrawal: boolean;
    public clinicalPrivilegesWithdrawal: boolean;
    public healthPlanParticipationDenial: boolean;
    public employmentTermination: boolean;
    public illegalDrugActivity: boolean;
    public sexualMisconductObject: boolean;
    public trainingProgramDisciplined: boolean;
    public voluntaryPrivilegeSurrender: boolean;
    public otherIssues: boolean;
    public details: string;

    constructor(jsonData: any = {}) {
        super();
        Object.assign(this, jsonData);
    }

    askForDetails(): boolean {
        return this.investigationSubject
            || this.convictedOrCharged
            || this.censured
            || this.licensingBoardInquirySubject
            || this.licenseWithdrawal
            || this.facilityMembershipWithdrawal
            || this.clinicalPrivilegesWithdrawal
            || this.healthPlanParticipationDenial
            || this.employmentTermination
            || this.illegalDrugActivity
            || this.sexualMisconductObject
            || this.trainingProgramDisciplined
            || this.voluntaryPrivilegeSurrender
            || this.otherIssues;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/liability/disciplinary-actions.model.ts